<template>
  <div class="mr-8 px-4 sm:px-6 lg:px-8">
    <div dir="rtl" class="mt-8 flex flex-col">
      <div class="sm:flex-auto">
        <h1 class="text-lg font-medium text-gray-900">انشاء حساب معلم</h1>
        <p class="mt-2 text-xs text-gray-700"></p>
      </div>
      <div class="mt-5 md:mt-0">
        <form @submit.prevent="createTeachers" ref="addTeacher">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-6 gap-6">

                <div class="col-span-6 sm:col-span-3">
                  <label for="fullname" class="block text-sm font-medium text-gray-700">الاسم الكامل</label>
                  <input type="text" name="fullName" id="fullName" v-model="fullName" placeholder="الاسم كامل"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required oninvalid="this.setCustomValidity('الرجاء ادخال الاسم كامل')"
                    oninput="setCustomValidity('')" />
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label for="email" class="block text-sm font-medium text-gray-700">الايميل</label>
                  <input type="text" name="email" id="email" v-model="email" placeholder="الايميل"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required oninvalid="this.setCustomValidity('الرجاء ادخال الايميل')" oninput="setCustomValidity('')"
                    @input="validateEmail" />
                  <span class="text-center text-red-500 text-xs" v-if="emailError">{{ emailError }}</span>
                </div>

                <!-- National ID field removed as it's not essential for app functionality -->

                <div class="col-span-6 sm:col-span-3">
                  <label for="email-address" class="block text-sm font-medium text-gray-700">رقم الهاتف</label>
                  <div class="mt-1 flex">
                    <span
                      class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">+966</span>
                    <input type="text" name="phoneNumber" id="phoneNumber" v-model="phoneNumber"
                      placeholder="رقم الهاتف"
                      class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      required oninvalid="this.setCustomValidity('الرجاء رقم رقم الهاتف')"
                      oninput="setCustomValidity('')" maxlength="9" minlength="9" />
                  </div>
                </div>


                <div class="col-span-6 sm:col-span-3">
                  <label for="country" class="block text-sm font-medium text-gray-700">المؤهل العلمي</label>
                  <select id="country" name="country" autocomplete="country-name"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                    v-model="qualificationValue">
                    <option disabled value="" selected>الرجاء اختيار المؤهل العلمي</option>
                    <option v-for="master in masterQualificationsList" :key="master.id" :value="master.id">
                      {{ master.qualificationValue }}</option>
                  </select>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label for="country" class="block text-sm font-medium text-gray-700">المنطقة</label>
                  <select id="country" name="country" autocomplete="country-name"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm pr-7"
                    v-model="regionId">
                    <option disabled value="" selected>الرجاء اختيار المنطقة</option>
                    <option v-for="master in masterRegionsList" :key="master.id" :value="master.id">
                      {{ master.regionNameAr }}</option>
                  </select>
                </div>

                <div class="col-span-6 sm:col-span-3">
                  <label for="password" class="block text-sm font-medium text-gray-700">
                    كلمة المرور
                  </label>
                  <input name="password" id="password" v-model="password" placeholder="الرقم السري"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')"
                    oninput="setCustomValidity('')" :type="showPassword ? 'text' : 'password'"
                    @input="validatePassword" />
                  <span v-if="passwordError" class="text-center text-red-500 text-xs">{{ passwordError }}</span>
                  <div class="block text-sm font-medium text-gray-700 mt-2 mr-2">
                    <input type="checkbox" v-model="showPassword" />
                    عرض كلمة المرور
                  </div>
                </div>
                <div class="col-span-6 sm:col-span-3">
                  <label for="confirmPassword" class="block text-sm font-medium text-gray-700">
                    اعادة ادخال كلمة المرور
                  </label>
                  <input name="confirmPassword" id="confirmPassword" v-model="confirmPassword" placeholder="الرقم السري"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    required oninvalid="this.setCustomValidity('الرجاء ادخال الرقم السري')"
                    oninput="setCustomValidity('')" :type="showPassword ? 'text' : 'password'"
                    @input="validatePassword" />
                  <span v-if="confirmPasswordError" class="text-center text-red-500 text-xs">{{ confirmPasswordError
                    }}</span>
                </div>

              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <button type="submit" :disabled="passwordSuccess" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm 
                text-sm font-medium rounded-md text-white bg-customHafadhColor
                hover:bg-customHafadhColorHover focus:outline-none focus:ring-2
                 focus:ring-offset-2 focus:ring-blue-500 " :class="{ 'cursor-not-allowed': passwordSuccess }">
                انشاء و تفعيل
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div v-if="showResponseModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div class="w-full max-w-xl rounded-lg bg-white shadow-xl">
        <div class="border-b px-6 py-4">
          <h3 class="text-base font-semibold text-gray-900">{{ responseModalTitle }}</h3>
        </div>
        <div class="max-h-80 overflow-y-auto px-6 py-4">
          <p class="whitespace-pre-line text-sm text-gray-700">{{ responseModalMessage }}</p>
        </div>
        <div class="flex justify-end border-t px-6 py-3">
          <button
            type="button"
            class="rounded-md bg-customHafadhColor px-4 py-2 text-sm font-medium text-white hover:bg-customHafadhColorHover"
            @click="closeResponseModal"
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/url';
import axios from 'axios';

class MasterQualificationsDto {
  constructor(data) {
    this.id = data.id || null;
    this.isActive = data.isActive || null;
    this.qualificationCode = data.qualificationCode || null;
    this.qualificationValue = data.qualificationValue || null;
  }
}

class MasterRegionsDto {
  constructor(data) {
    this.id = data.id || null;
    this.countryCode = data.countryCode || null;
    this.regionCode = data.regionCode || null;
    this.regionNameAr = data.regionNameAr || null;
    this.regionNameEn = data.regionNameEn || null;
  }
}

export default {
  data() {
    return {
      fullName: "",
      email: "",
      // idNumber: "", // Removed as it's not essential for app functionality
      phoneNumber: "",
      password: "",
      confirmPassword: "",
      qualificationValue: '',
      regionId: '',
      showPassword: false,
      emailError: "",
      passwordError: '',
      passwordSuccess: true,
      confirmPasswordError: '',
      masterQualificationsList: [],
      masterRegionsList: [],
      showResponseModal: false,
      responseModalTitle: '',
      responseModalMessage: '',
    }
  }, mounted() {
    this.masterQualifications();
    this.masterRegions();
  }, methods: {
    validateEmail() {
      // Regular expression for basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email) && this.email.length != 0) {
        this.emailError = "الرجاء ادخال الايميل بشكل صحيح";
      } else {
        this.emailError = "";
      }
    },
    async createTeachers() {
      try {
        const response = await axios.post(process.env.VUE_APP_SERVICE_URL + url.create_teachers,
          {
            fullName: this.fullName,
            email: this.email,
            password: this.password,
            // nationalId: this.idNumber, // Removed as it's not essential for app functionality
            phone: this.phoneNumber,
            qualificationId: this.qualificationValue,
            regionId: this.regionId,
            description: this.description || ""
          },
          {
            headers: {
              'X-Authorization': localStorage.getItem('token'),
            },
          }
        );
        if (response != undefined) {
          console.log(response);
          this.$refs.addTeacher.reset();
          this.responseModalTitle = 'تمت العملية بنجاح';
          this.responseModalMessage = response.data?.result?.mesAr || 'تم إنشاء حساب المعلم بنجاح';
          this.showResponseModal = true;
        }
      } catch (error) {
        console.log(error);
        const apiErrorMessage = this.extractApiErrorMessage(error);
        this.responseModalTitle = 'تعذر إنشاء حساب المعلم';
        this.responseModalMessage = apiErrorMessage;
        this.showResponseModal = true;
      }
    },
    closeResponseModal() {
      this.showResponseModal = false;
      this.responseModalTitle = '';
      this.responseModalMessage = '';
    },
    extractApiErrorMessage(error) {
      const responseData = error?.response?.data || {};

      // Laravel-style validation errors: { errors: { field: ["msg1", "msg2"] } }
      if (responseData.errors && typeof responseData.errors === 'object') {
        const formatted = this.formatValidationErrors(responseData.errors);
        if (formatted) return formatted;
      }

      // Project-style validation errors: { result: { data: { field: ["msg1"] } } }
      if (responseData?.result?.data && typeof responseData.result.data === 'object') {
        const formatted = this.formatValidationErrors(responseData.result.data);
        if (formatted) return formatted;
      }

      return (
        responseData.messageAr ||
        responseData.message ||
        responseData?.result?.mesAr ||
        error?.message ||
        'حدث خطأ ما الرجاء المحاولة مرة اخرى'
      );
    },
    formatValidationErrors(errorsObject) {
      if (!errorsObject || typeof errorsObject !== 'object') return '';

      const fieldLabelMap = {
        fullName: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        password: 'كلمة المرور',
        nationalId: 'رقم الهوية',
        qualificationId: 'المؤهل العلمي',
        regionId: 'المنطقة',
        phone: 'رقم الجوال',
        description: 'الوصف',
      };

      const detailedErrors = Object.entries(errorsObject)
        .flatMap(([field, value]) => {
          const messages = Array.isArray(value) ? value : [value];
          const label = fieldLabelMap[field] || field;
          return messages
            .filter(Boolean)
            .map((message) => `${label}: ${message}`);
        });

      if (detailedErrors.length === 0) return '';

      return `يرجى تصحيح البيانات التالية:\n- ${detailedErrors.join('\n- ')}`;
    },
    masterQualifications() {
      // Get tenant_id from JWT token
      let tenantId = null;
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const payload = JSON.parse(atob(token.split('.')[1]));
          tenantId = payload.tenantId || payload.tenant_id || null;
        }
      } catch (e) {
        console.warn('Could not extract tenantId from token:', e);
      }

      // Build URL with tenantId as query parameter
      let urlWithParams = url.master_qualifications;
      if (tenantId) {
        urlWithParams += `?tenantId=${encodeURIComponent(tenantId)}`;
      }

      axios.get(process.env.VUE_APP_SERVICE_URL + urlWithParams)
        .then(response => {
          this.masterQualificationsList = response.data.result.data.map(data => new MasterQualificationsDto(data));
          console.log(this.masterQualificationsList);
        })
        .catch(error => {
          console.error('Error fetching data', error);
        });
    },
    masterRegions() {
      axios.get(process.env.VUE_APP_SERVICE_URL + url.master_regions,
        {
          headers: {
            'X-Authorization': localStorage.getItem('token'),
          }
        },
      )
        .then(response => {
          this.masterRegionsList = response.data.result.data.map(data => new MasterRegionsDto(data));
          console.log(this.masterRegionsList);
        })
        .catch(error => {
          console.error('Error fetching data', error);
        });
    },
    validatePassword() {
      // Reset error messages
      this.passwordError = '';
      this.confirmPasswordError = '';

      const specialCharRegex = /[@#!]/i;
      const uppercaseRegex = /[A-Z]/;
      const lowercaseRegex = /[a-z]/;
      const numberRegex = /[0-9]/;

      if (specialCharRegex.test(this.password) && uppercaseRegex.test(this.password) &&
        lowercaseRegex.test(this.password) && numberRegex.test(this.password)) {
        if (this.password !== this.confirmPassword && this.confirmPassword) {
          this.confirmPasswordError = 'كلمة المرور غير متطابقة';
          this.passwordSuccess = true;
        }
        else {
          this.passwordSuccess = false;
        }
      } else if (this.password) {
        this.passwordError =
          'الرقم السري يجب أن يكون بين 8 و 15 حرفا, الرقم السري يجب أن يكون مكون من علامة مميزة مثل "@#!" , يجب أن تحتوي كلمة المرور على أحرف كبيرة و صغيرة';
        this.passwordSuccess = true;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
